import React, { useState } from "react";
import Sidebar from "../../containers/Sidebar/Sidebar";

const AppLayout = ({ children }) => {
  const [visible, setVisible] = useState(true);
  return (
    <div className="flex flex-col md:flex-row">
      <Sidebar setVisible={setVisible} visible={visible} />
      <main className="w-full">{children}</main>
    </div>
  );
};

export default AppLayout;
